const initState = {
    /// README: IMPORTANT (do not remove without authority)
    floorid: null,
    floorMeta: null,
    elevationMeta: null,

    /// README: NEW PART MODAL
    isFloorCreating: false,
    isFloorCreated: false,

    /// README: PROJECT API CALL
    fapiMessage: "",
    fapiIsDoneAndSent: false,
    showFapiLoader: false,
    fapid: -1,
}

const floorReducer = (state = initState, action) => {
    /// README: PART SETTING AND INITIALIZE
    if (action.type === "SET_CURRENT_FLOOR_ID") {
        return {
            ...state,
            floorid: action.floorid,
        }
    }
    else if (action.type === "CLEAR_FLOOR_ID") {
        return {
            ...state,
            floorid: null,
        }
    }
    else if (action.type === "SET_CURRENT_ELEVATION_META") {
        return {
            ...state,
            elevationMeta: action.elevationMeta,
        }
    }

    /// README: NEW PART CREATION
    else if (action.type === "OPEN_NEW_FLOOR_MODAL") {
        return {
            ...state,
            isFloorCreating: false,
            isFloorCreated: false,
            floorid: null,
        }
    }
    else if (action.type === "ADD_NEW_FLOOR") {
        return {
            ...state,
            isFloorCreating: true,
        }
    }
    else if (action.type === "NEW_FLOOR_ADDED") {
        return {
            ...state,
            isFloorCreating: false,
            isFloorCreated: true,
            floorid: action.floorid
        }
    }

    /// README: PART UPDATING
    else if (action.type === "FLOOR_NAME_UPDATE") {
        return {
            ...state,
        }
    }
    else if (action.type === "DELETE_FLOOR") {
        return {
            ...state,
        }
    }

    /// README: PROJECT API CALLS
    else if (action.type === 'FAPI_CALL_RESET') {
        return {
            ...state,
            fapiMessage: null,
            showFapiLoader: false,
            fapid: -1,
            fapiIsDoneAndSent: false,
        }
    }
    else if (action.type === "FAPI_CALL_INIT") {
        // console.log(action.fapiMessage)
        return {
            ...state,
            fapiMessage: action.fapiMessage,
            showFapiLoader: action.showFapiLoader,
            fapid: action.fapid,
            fapiIsDoneAndSent: action.fapiIsDoneAndSent ?? false,
        }
    }
    else if (action.type === "FAPI_CALL_COMPLETED" || action.type === "FAPI_CALL_ERROR") {
        // console.log(action.fapiMessage)
        return {
            ...state,
            fapiMessage: action.fapiMessage,
            showFapiLoader: action.showFapiLoader,
            fapid: action.fapid,
            fapiIsDoneAndSent: action.fapiIsDoneAndSent ?? false,
        }
    }
    return state;
}

export default floorReducer;